export default __webpack_public_path__ + "static/media/Claude_Monet_Sun_setting_over_the_Seine_50_x_70_cm.e52ff623.jpg";